const months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
export const getLast5Months = () => {
    const currentMonth = new Date().getMonth();
    return Array.from({ length: 5 }, (v, i) => months[(currentMonth - i + 12) % 12]).reverse();
};